import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { formatCurrencyFollowLocale } from '../../../../helpers/value'
import { CURRENCY } from '../../../../utils/currency'
import {
  selectDetailRequestTableById,
  selectDetailRequestTableIds,
  selectLoadingDetailRequestTable,
} from '../store/slice'
import { DETAIL_TABLE_SCHEMA, REQUEST_INFO_SCHEMA } from './constants'

export const DetailTable = () => {
  const ids = useSelector(selectDetailRequestTableIds)
  const isLoading = useSelector(selectLoadingDetailRequestTable)
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Panel
      label="userManagement.packageSubManagement.REQUEST_DETAILS_PANEL"
      isI18n
    >
      <Element>
        <Table
          ids={ids}
          isNoDataWithHead
          getDataFromRedux={selectDetailRequestTableById}
          schema={getSchema(locale)}
          isLoading={isLoading}
          autoHeightMax={300}
        />
      </Element>
    </Panel>
  )
}

const getSchema = (locale) => {
  return DETAIL_TABLE_SCHEMA.map((item) => {
    const result = {
      title: <Translate value={item.title} />,
      colId: item.key,
    }

    return {
      ...result,
      render: (val) => {
        if (item.key === REQUEST_INFO_SCHEMA.rightSchema.totalPrice.key)
          return <>{formatCurrencyFollowLocale(val, CURRENCY.VND, locale)}</>
        return val
      },
    }
  })
}
